export default "__VITE_ASSET__B0kR1KRI__"